import React, { useEffect, useState, useRef } from 'react';
import './MysticaReplica.css'; // Reusing the same CSS
import ClickSpark from '../blocks/ClickSpark/ClickSpark';
import BlurText from '../blocks/BlurText/BlurText';
import MetaBalls from '../blocks/MetaBalls/MetaBalls';
import { CSSProperties } from 'react';
import '../components/OthersPage.css'; // We'll create this file next

// Types for the API responses
interface ItchUser {
  id: number;
  url: string;
  press_user: boolean;
  gamer: boolean;
  developer: boolean;
  cover_url: string;
  username: string;
}

interface ItchUserResponse {
  user: ItchUser;
}

interface ItchGame {
  id: number;
  title: string;
  url: string;
  cover_url: string;
  short_text?: string;
  views_count: number;
  downloads_count: number;
  published_at?: string;
  classification: string;
  created_at: string;
  can_be_bought: boolean;
  min_price?: number;
  p_android?: boolean;
  p_osx?: boolean;
  p_linux?: boolean;
  p_windows?: boolean;
  purchases_count?: number;
  type?: string;
  published?: boolean;
  embed?: {
    width: number;
    height: number;
    fullscreen: boolean;
  };
  in_press_system?: boolean;
  has_demo?: boolean;
  user?: {
    [key: string]: any; 
  };
}

interface ItchGamesResponse {
  games: ItchGame[];
}

// Custom styles for the Others page
const titleStyle: CSSProperties = {
  fontFamily: 'Cinzel, serif',
  fontWeight: 700,
  fontSize: '7rem',
  letterSpacing: '0.05em',
  color: 'var(--text-color)',
  textTransform: 'uppercase',
  margin: 0,
  padding: 0
};

// Custom styles for the profile in header
const profileHeaderStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 0'
};

const profileImageStyle: CSSProperties = {
  width: '120px',
  height: '120px',
  borderRadius: '50%',
  objectFit: 'cover',
  border: '4px solid var(--text-color)',
  boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
  marginBottom: '1.5rem',
  transition: 'all 0.3s ease'
};

const profileNameStyle: CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '2rem',
  color: 'var(--text-color)',
  margin: 0,
  textAlign: 'center'
};

// Mock data for development/fallback
const MOCK_USER: ItchUser = {
  id: 7078744,
  url: "https://bellinimoon.itch.io",
  press_user: false,
  gamer: true,
  developer: true,
  cover_url: "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
  username: "bellinimoon"
};

// Mock game data for development/fallback
const MOCK_GAMES: ItchGame[] = [
  {
    "created_at": "2023-10-15 20:59:30",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/acapellasimulator",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2315459,
    "views_count": 25,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "A cappella simulator - a prototype",
    "published_at": "2023-10-15 20:59:55",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 700,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzNzIwMDUzLnBuZw==/315x250%23c/hjzsU2.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-11-20 21:24:02",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/amir",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2378890,
    "views_count": 83,
    "p_linux": false,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "title": "Amir",
    "published_at": "2023-11-20 21:29:56",
    "classification": "game",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 700,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzE0NzU0MDAwLnBuZw==/315x250%23c/Rh2X7r.png",
    "short_text": "Merchants have no country.",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-05-05 15:33:02",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/casserole",
    "purchases_count": 0,
    "type": "default",
    "p_osx": false,
    "id": 2054782,
    "views_count": 33,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "cover_url": "https://img.itch.zone/aW1nLzEyMDgzMzEyLnBuZw==/315x250%23c/IJzpqI.png",
    "title": "CasseRole",
    "published_at": "2023-05-05 15:36:35",
    "p_linux": false,
    "p_windows": false,
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-10-01 01:11:54",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/desklamp",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2290377,
    "views_count": 14,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Desk Lamp - a prototype",
    "published_at": "2023-10-01 01:18:47",
    "p_windows": false,
    "embed": {
      "width": 960,
      "height": 650,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzNTcyNzY4LnBuZw==/315x250%23c/rMaDJ1.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-05-25 15:01:13",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/igd01",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2086467,
    "views_count": 10,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Gate Tower",
    "published_at": "2023-05-30 22:11:02",
    "p_windows": false,
    "embed": {
      "width": 960,
      "height": 650,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEyMzMxMjgxLnBuZw==/315x250%23c/2oNSaj.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2024-03-15 01:54:20",
    "can_be_bought": false,
    "downloads_count": 87,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/gismonda",
    "purchases_count": 0,
    "type": "default",
    "p_osx": true,
    "id": 2584853,
    "short_text": "You, too, must prove your worth!",
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "cover_url": "https://img.itch.zone/aW1nLzE2MDk1MzEwLnBuZw==/315x250%23c/vg9Vnb.png",
    "title": "Gismonda",
    "published_at": "2024-03-15 02:01:16",
    "p_linux": false,
    "p_windows": true,
    "classification": "game",
    "views_count": 324,
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-06-28 21:13:41",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/igd03",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2139093,
    "views_count": 20,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Guillemot",
    "published_at": "2023-06-28 21:44:21",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 700,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzEyNjEyNDUxLnBuZw==/315x250%23c/p4Q5jK.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-08-10 18:46:41",
    "can_be_bought": false,
    "downloads_count": 2,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/harrypotter-rps",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2212942,
    "views_count": 24,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "HarryPotter RPS",
    "published_at": "2023-08-29 22:55:46",
    "p_windows": false,
    "embed": {
      "width": 640,
      "height": 640,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzMjcyNjc4LnBuZw==/315x250%23c/13HxhJ.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-06-15 04:45:49",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/igd02",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2118752,
    "views_count": 10,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "IGD_Assignment02_FlatGame",
    "published_at": "2023-06-15 05:20:03",
    "p_windows": false,
    "embed": {
      "width": 970,
      "height": 660,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzEyNDc3MDQyLnBuZw==/315x250%23c/M%2FYKlz.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2025-01-27 04:34:48",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/mc-eschers-equestrian-armageddon-2",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 3277991,
    "views_count": 19,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "MC Escher's Equestrian Armageddon 2",
    "published_at": "2025-01-27 04:40:41",
    "p_windows": false,
    "embed": {
      "width": 960,
      "height": 540,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzE5NTYxMjYxLnBuZw==/315x250%23c/u8k7EG.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-08-10 08:45:47",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/mystica-replica",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2212230,
    "views_count": 24,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Mystica Replica",
    "published_at": "2023-08-10 08:49:16",
    "p_windows": false,
    "embed": {
      "width": 950,
      "height": 700,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzMDg0MjE0LnBuZw==/315x250%23c/7I8Kgg.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-07-13 06:29:04",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/igd04",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2168711,
    "views_count": 16,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Pin Monkey",
    "published_at": "2023-07-13 06:31:43",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 700,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEyNzk3NTY1LnBuZw==/315x250%23c/6KUzD0.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2022-12-09 03:05:33",
    "can_be_bought": false,
    "downloads_count": 1,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/ratemig",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 1827836,
    "views_count": 14,
    "p_linux": false,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "title": "Rate Mig",
    "published_at": "2022-12-09 03:19:20",
    "classification": "game",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 500,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEwNzI4ODE3LnBuZw==/315x250%23c/PyGMVE.png",
    "short_text": "bird adventure",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2024-01-17 14:23:09",
    "can_be_bought": false,
    "downloads_count": 64,
    "min_price": 0,
    "p_android": false,
    "url": "https://pengguo.itch.io/scrollden",
    "purchases_count": 0,
    "type": "default",
    "p_osx": false,
    "id": 2475366,
    "short_text": "Build a home with mythological creatures and explore an ancient map and story inspired by Chinese mythologies.",
    "user": {
      "id": 2318123,
      "url": "https://pengguo.itch.io",
      "username": "PengGuo"
    },
    "published": true,
    "cover_url": "https://img.itch.zone/aW1nLzE0Njk2MTY5LnBuZw==/315x250%23c/BKPGhk.png",
    "views_count": 24,
    "classification": "game",
    "p_linux": false,
    "p_windows": true,
    "title": "Scrollden",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-10-10 05:00:34",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/storytree",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2306753,
    "views_count": 5,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Story Tree - a prototype",
    "published_at": "2023-10-10 05:01:26",
    "p_windows": false,
    "embed": {
      "width": 1000,
      "height": 700,
      "fullscreen": false
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzNjY5ODc4LnBuZw==/315x250%23c/fI7%2BPp.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-09-18 01:36:35",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/tomjerry",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2268417,
    "views_count": 29,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "TOM-JERRY",
    "published_at": "2023-09-18 01:37:45",
    "p_windows": false,
    "embed": {
      "width": 960,
      "height": 650,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzNDQzNzE5LnBuZw==/315x250%23c/owFBaA.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-09-13 03:39:36",
    "can_be_bought": false,
    "downloads_count": 0,
    "min_price": 0,
    "p_android": false,
    "url": "https://bellinimoon.itch.io/typemurderer",
    "purchases_count": 0,
    "type": "html",
    "p_osx": false,
    "id": 2259911,
    "views_count": 39,
    "user": {
      "id": 7078744,
      "url": "https://bellinimoon.itch.io",
      "cover_url": "https://img.itch.zone/aW1nLzE1NTIwOTMxLnBuZw==/100x100%23/e8h5go.png",
      "username": "bellinimoon"
    },
    "published": true,
    "p_linux": false,
    "title": "Type Murderer",
    "published_at": "2023-09-13 03:39:50",
    "p_windows": false,
    "embed": {
      "width": 700,
      "height": 700,
      "fullscreen": true
    },
    "cover_url": "https://img.itch.zone/aW1nLzEzMzk4Nzk0LnBuZw==/315x250%23c/K5T%2Bau.png",
    "classification": "game",
    "in_press_system": false,
    "has_demo": false
  },
  {
    "created_at": "2023-12-12 13:18:25",
    "can_be_bought": false,
    "downloads_count": 18,
    "min_price": 0,
    "p_android": false,
    "url": "https://bowenwang0620.itch.io/gundum-rising",
    "purchases_count": 0,
    "type": "default",
    "p_osx": true,
    "id": 2418708,
    "short_text": "Assemble it yours own \"Gundum\"!",
    "user": {
      "id": 6601061,
      "url": "https://bowenwang0620.itch.io",
      "username": "bowenwang0620"
    },
    "published": true,
    "cover_url": "https://img.itch.zone/aW1nLzE0MzE1MjA2LnBuZw==/315x250%23c/KhZZfs.png",
    "title": "🤖 Gundum Rising",
    "published_at": "2023-12-12 14:31:00",
    "p_linux": false,
    "p_windows": true,
    "classification": "game",
    "views_count": 96,
    "in_press_system": false,
    "has_demo": false
  }
];

const Others: React.FC = () => {
  const [user, setUser] = useState<ItchUser | null>(MOCK_USER);
  const [games, setGames] = useState<ItchGame[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Use the mock user data directly
  const displayUser = user;

  // Format the date from ISO string to readable format
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  // Sort games in the required order
  useEffect(() => {
    // Get the specific games we want at the top
    const gismonda = MOCK_GAMES.find(game => game.title === "Gismonda");
    const scrollden = MOCK_GAMES.find(game => game.title === "Scrollden");
    const amir = MOCK_GAMES.find(game => game.title === "Amir");
    const gundum = MOCK_GAMES.find(game => game.title === "🤖 Gundum Rising");

    // Filter out the specific games to get the remaining ones
    const restOfGames = MOCK_GAMES.filter(game => 
      game.title !== "Gismonda" && 
      game.title !== "Scrollden" && 
      game.title !== "Amir" && 
      game.title !== "🤖 Gundum Rising"
    );

    // Sort the rest by view count in descending order
    const sortedRest = [...restOfGames].sort((a, b) => b.views_count - a.views_count);

    // Combine in the specified order
    const sortedGames = [
      gismonda,
      scrollden,
      amir,
      gundum
    ].filter(Boolean) as ItchGame[];

    // Add the rest of the sorted games
    setGames([...sortedGames, ...sortedRest]);
  }, []);

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper function to get the correct URL for a game
  const getGameUrl = (game: ItchGame): string => {
    // If it's Scrollden, return the Steam link
    if (game.title === "Scrollden") {
      return "https://store.steampowered.com/app/2892420/Scrollden/";
    }
    // Otherwise return the original URL
    return game.url;
  };

  return (
<ClickSpark
                shape="heart"
                sparkColor='#BD2735'
                sparkSize={8}
                sparkRadius={40}
                sparkCount={16}
                duration={500}
              >      <div className="project-page others-page">
        <div className="home-link">
          <div className="metaball-wrapper">
            <MetaBalls 
              color="#266867" 
              enableTransparency={true}
              ballCount={8}
              animationSize={25}
              speed={0.2}
              cursorBallColor="#266867"
            />
          </div>
          <a href="/">Home</a>
        </div>

        <header className="project-header">
          <div className="container">
            {displayUser && (
              <a href={displayUser.url} target="_blank" rel="noopener noreferrer" style={profileHeaderStyle}>
                <img src={displayUser.cover_url} alt={displayUser.username} style={profileImageStyle} />
                <h2 style={profileNameStyle}>{displayUser.username} on itch.io</h2>
              </a>
            )}
            {!displayUser && loading && (
              <div style={profileHeaderStyle}>
                <div className="loading-spinner"></div>
                <p>Loading profile...</p>
              </div>
            )}
          </div>
        </header>

        <main className="others-content">
          {/* Games Grid */}
          {loading ? (
            <div className="loading">
              <div className="loading-spinner"></div>
              <p>Loading awesome projects...</p>
            </div>
          ) : error ? (
            <div className="error">{error}</div>
          ) : (
            <section className="games-grid">
              {games.map((game) => (
                <div key={game.id} className="game-card">
                  <a href={getGameUrl(game)} target="_blank" rel="noopener noreferrer" className="game-link">
                    <div className="game-image-container">
                      <img src={game.cover_url} alt={game.title} className="game-image" />
                    </div>
                    <div className="game-info">
                      <h3 className="game-title">{game.title}</h3>
                      {game.short_text && <p className="game-description">{game.short_text}</p>}
                      <div className="game-meta">
                        <span className="game-views">{game.views_count} views</span>
                        <span className="game-downloads">{game.downloads_count} downloads</span>
                        <span className="game-date">{game.published_at ? formatDate(game.published_at) : ''}</span>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </section>
          )}
        </main>
      </div>
    </ClickSpark>
  );
};

export default Others; 